export default __webpack_public_path__ + "static/inventory-optimisation-2-f8255b7e22cc2758f059eb353b00655b.webp";